import { render, staticRenderFns } from "./SendEmailButton.vue?vue&type=template&id=11a70f4c&"
import script from "./SendEmailButton.vue?vue&type=script&lang=js&"
export * from "./SendEmailButton.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports